class localhostSettings { }

const win: any = window;
if (window.location.href.includes("localhost")) {
    !!!win["base_api_url"] && (win["base_api_url"] = "https://apisit.mobily.com.sa/api");
}

export default localhostSettings;
